module.exports = __webpack_public_path__ + "img/Opplysningstid_Tida-og-samfunnsforholdene1.7aba9735.jpg";